export default __webpack_public_path__ + "static/media/tretsyak_old_page.4d447020.jpg";